module.exports = __webpack_public_path__ + "media/src/images/partners/pavia-2e59339ec802f1db953af87ffd472731.jpg";